import { AODSvgExport } from "@/src/svg/admissionOfficeDatabase/AODSvgExport";

const defaultWidth = 5;

export const admissionDatabaseActionsConst = [
  { name: "prev", icon: AODSvgExport.AODPrevDocSvg },
  { name: "comment", icon: AODSvgExport.AODCommentDocSvg },
  { name: "download", icon: AODSvgExport.AODDownloadDocSvg },
  { name: "send-email", icon: AODSvgExport.AODSendEmailSvg },
  { name: "delete", icon: AODSvgExport.AODDeleteDocSvg },
];

export const admissionDatabaseIsAvailableConst = [
  { id: "true", label: "true" },
  { id: "false", label: "false" },
] as const;

export const resolveAdmissionDatabaseIsAvailableId = (value?: boolean | null): "true" | "false" => {
  return value === false ? "false" : "true";
};

export const resolveAdmissionDatabaseIsAvailableLabel = (value?: boolean | null): string => {
  return value === false ? "false" : "true";
};

export const admissionDatabaseAllFieldsList = [
  { title: "Date", id: "data_added", width: defaultWidth },
  { title: "Full Name", id: "full_name", width: defaultWidth },
  { title: "Title", id: "title", width: defaultWidth },
  { title: "Type", id: "document_type", width: defaultWidth },
  { title: "Seria", id: "document_seria", width: defaultWidth },
  { title: "Data of Birth", id: "date_of_birth", width: defaultWidth },
  { title: "Nationality", id: "nationality", width: defaultWidth },
  { title: "Course", id: "course", width: defaultWidth },
  { title: "Whose", id: "whose_doc", width: defaultWidth },
  { title: "Is Available", id: "is_available", width: defaultWidth },
];

export const admissionDatabaseDefaultConfiguration = [
  { title: "Date", id: "data_added", width: 5.5 },
  { title: "Full Name", id: "full_name", width: 14 },
  { title: "Title", id: "title", width: 6.875 },
  { title: "Type", id: "document_type", width: 6 },
  { title: "Seria", id: "document_seria", width: 6.313 },
  { title: "Data of Birth", id: "date_of_birth", width: 5.5 },
  { title: "Nationality", id: "nationality", width: 6.5 },
  { title: "Course", id: "course", width: 11.625 },
  { title: "Whose", id: "whose_doc", width: 5.875 },
  { title: "Is Available", id: "is_available", width: 5.5 },
  // { title: "Actions", id: "document_actions", width: 9 },
];

export const admissionDatabaseDefaultBodyFilters = {
  page: 1,
  query: "",
  start: "",
  end: "",
  types: [],
  nationalities: [],
  courses: [],
  whose_docs: [],
  titles: [],
};

type AODColumnConfig = { title: string; id: string; width?: number };

export function normalizeVisibleAODColumns(columns: AODColumnConfig[]): AODColumnConfig[] {
  const knownIds = new Set(admissionDatabaseAllFieldsList.map((col) => col.id));
  const next = columns
    .filter((col) => knownIds.has(col.id))
    .map((col) => {
      const canonical = admissionDatabaseAllFieldsList.find((c) => c.id === col.id);
      return { ...canonical!, width: col.width ?? canonical?.width ?? defaultWidth };
    });

  if (!next.some((col) => col.id === "is_available")) {
    const isAvailableCol = admissionDatabaseAllFieldsList.find((c) => c.id === "is_available");
    if (isAvailableCol) {
      const whoseIndex = next.findIndex((c) => c.id === "whose_doc");
      if (whoseIndex >= 0) {
        next.splice(whoseIndex + 1, 0, { ...isAvailableCol });
      } else {
        next.push({ ...isAvailableCol });
      }
    }
  }

  return next;
}
